import { api } from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createSubcategory = createAsyncThunk(
  "playlist-subcategory/createSubcategory",
  async ({ token, payload }) => {
    const response = await api.post(
      "/playlist-subcategory",
      { ...payload },
      { token }
    );
    return response.data;
  }
);

export const updateSubcategory = createAsyncThunk(
  "playlist-subcategory/updateSubcategory",
  async ({ token, id, payload }) => {
    const response = await api.patch(
      `/playlist-subcategory/${id}`,
      { ...payload },
      { token }
    );
    return response.data;
  }
);

export const deleteSubcategory = createAsyncThunk(
  "playlist-subcategory/deleteSubcategory",
  async ({ id, token }) => {
    const response = await api.delete(`/playlist-subcategory/${id}`, { token });
    return response.data;
  }
);

export const getSubcategory = createAsyncThunk(
  "playlist-subcategory/createSubcategory",
  async () => {
    const response = await api.get("/playlist-subcategory");
    return response.data;
  }
);

export const getBasicSubcategoriesInfo = createAsyncThunk(
  "playlist-subcategory/BasicSubcategoriesInfo",
  async ({ token, ...queryParams }) => {
    const response = await api.get(
      "/playlist-subcategory/basic-subcategories/info",
      {
        token,
        params: queryParams,
      }
    );
    return response.data;
  }
);
